import React from "react";
import RequestPageMUI from "./RequestPageMUI";

const DammaSermensRequest = () => {
    return (
        <RequestPageMUI 
            title="Sermons Requests"
            fetchUrl="/get-sermon-requests"
            editEndpoint="edit-sermon-request"
            deleteEndpoint="sermon-request"
            statusEndpoint="sermon-request"
            dateFields={['date', 'created_at', 'updated_at']}
            hiddenFields={['ip_address']} // Hide IP address from view if needed
        />
    );
};

export default DammaSermensRequest;